// extracted by mini-css-extract-plugin
export default {"image":"SelectSellitemsEditor_image__kwr7u","list":"SelectSellitemsEditor_list__-waBc","price":"SelectSellitemsEditor_price__YK7hg","wrapper":"SelectSellitemsEditor_wrapper__vGoS7"};